import React, { useRef, useState } from "react";
import { FaFileImport } from "react-icons/fa";
import { toast } from "react-toastify";

import { importManualPiecesFromKmlFile } from "../../utils/kmlImportUtils";

function ServiceOrderKmlImportButton({
  t,
  manualPieces,
  onManualPiecesChange,
  disabled,
}) {
  const inputRef = useRef(null);
  const [importing, setImporting] = useState(false);

  const handlePickFile = () => {
    if (disabled || importing) return;
    if (inputRef.current) {
      inputRef.current.click();
    }
  };

  const handleFileChange = async (event) => {
    const file = event.target.files && event.target.files[0];
    event.target.value = "";
    if (!file) return;

    setImporting(true);
    try {
      const nextPieces = await importManualPiecesFromKmlFile(file, manualPieces);
      const addedCount = nextPieces.length - (manualPieces || []).length;
      onManualPiecesChange(nextPieces);
      toast.success(
        t("{{count}} trecho(s) importado(s) de {{file}}.", {
          count: addedCount,
          file: file.name,
        }),
        { position: "bottom-right" }
      );
    } catch (error) {
      toast.error(
        error && error.message
          ? error.message
          : t("Não foi possível importar o arquivo."),
        { position: "bottom-right" }
      );
    } finally {
      setImporting(false);
    }
  };

  return (
    <>
      <input
        ref={inputRef}
        type="file"
        accept=".kml,.kmz,application/vnd.google-earth.kml+xml,application/vnd.google-earth.kmz"
        style={{ display: "none" }}
        onChange={handleFileChange}
      />
      <button
        type="button"
        className="service-order-location__map-open-btn is-kml"
        onClick={handlePickFile}
        disabled={disabled || importing}
        title={t("Importar KML/KMZ")}
      >
        <FaFileImport size={18} />
        <span>{importing ? t("Importando...") : t("Importar KML/KMZ")}</span>
      </button>
    </>
  );
}

export default ServiceOrderKmlImportButton;
